import type { Theme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export function checkbox(theme: Theme) {
  return {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: 0,

          // REMOVE the weird round hover background
          "&:hover": {
            backgroundColor: "transparent !important",
          },
        },
      },
      defaultProps: {
        disableRipple: true, // recommended so ripple doesn't appear

        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7 2C4.23858 2 2 4.23858 2 7V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2H7ZM7.5 3.5C5.29086 3.5 3.5 5.29086 3.5 7.5V16.5C3.5 18.7091 5.29086 20.5 7.5 20.5H16.5C18.7091 20.5 20.5 18.7091 20.5 16.5V7.5C20.5 5.29086 18.7091 3.5 16.5 3.5H7.5Z"
              fill="#637381"
            />
          </svg>
        ),

        checkedIcon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17 2C19.7614 2 22 4.23858 22 7V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7C2 4.23858 4.23858 2 7 2H17ZM16.6152 9.25488C16.2753 8.9149 15.715 8.91494 15.375 9.25488L11.2451 13.3848L9.49512 11.6348C9.15513 11.2948 8.59487 11.2948 8.25488 11.6348C7.9149 11.9747 7.91494 12.525 8.25488 12.875L10.6348 15.2451C10.8048 15.4151 11.0251 15.4951 11.2451 15.4951C11.4751 15.4951 11.6953 15.4151 11.8652 15.2451L16.6152 10.4951C16.9552 10.1551 16.9552 9.60487 16.6152 9.25488Z"
              fill="#009CA7"
            />
          </svg>
        ),

        indeterminateIcon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7 2C4.23858 2 2 4.23858 2 7V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2H7ZM7.5 3.5C5.29086 3.5 3.5 5.29086 3.5 7.5V16.5C3.5 18.7091 5.29086 20.5 7.5 20.5H16.5C18.7091 20.5 20.5 18.7091 20.5 16.5V7.5C20.5 5.29086 18.7091 3.5 16.5 3.5H7.5Z"
              fill="#637381"
            />
            <rect x="7.5" y="11" width="9" height="2" rx="1" fill="#3192D0" />
          </svg>
        ),
      },
    },
  };
}
